export default __webpack_public_path__ + "f5fa074c54284cd249eb709432ad24ea.png";